import { environment as base } from './environment.local';

export const environment = {
  ...base,
  webApiUrl: 'https://odqservicegestionodqfarp-dev.azurewebsites.net/api',
  legalEntityCommandApi: 'https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/legalentity-commandapi/api',
  legalEntityQueryApi: 'https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/legalentity-queryapi/api',
  continuingEducationCommandApi: 'https://odq-platine-backend-f6fnbcg9amaza9b4.z01.azurefd.net/continuingeducation-commandapi/api',
  documentStorageUrl: 'https://platinepersistence.blob.core.windows.net',
  inspectionEnabled: true,
  firebase: {
    apiKey: 'AIzaSyBlAEqpEXG0cSXzvXG6HwsMG6DEhHfbpzc',
    authDomain: 'platine-backoffice.firebaseapp.com',
    databaseURL: 'https://platine-backoffice.firebaseio.com',
    projectId: 'platine-backoffice',
    storageBucket: 'platine-backoffice.appspot.com',
    messagingSenderId: '124934093345',
    appId: '1:124934093345:web:76c1bb5fd480690d',
  },
  functions: {
    baseUrl: 'https://odqplatineportalfuncs-dev.azurewebsites.net/api',
  },
};
